// Angular dependencies.
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

// App dependencies.
import { initialState } from './app.reducer';
import { AppEffects } from './app.effects';
import { CreepsEffects } from './creeps.effects';
import { CreepEffects } from './creep.effects';

@NgModule({
  imports: [
    StoreModule.forRoot(initialState),
    EffectsModule.forRoot([
      AppEffects,
      CreepsEffects,
      CreepEffects
    ])
  ],
  exports: [StoreModule, EffectsModule]
})
export class AppStoreModule { }



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/store.module.ts